module.exports = __webpack_public_path__ + "files/2175be2f09b36c9de4f60b62daf26e15.png";